
import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import ScrollReveal from "@/components/ui/scroll-reveal";
import { useTranslation } from "@/hooks/useTranslation";

const FAQ = () => {
  const { t } = useTranslation();
  
  const faqs = t("faq.questions") as unknown as Array<{ q: string; a: string }>;

  return (
    <section className="section-padding bg-gray-50">
      <div className="container mx-auto px-4">
        <ScrollReveal>
          <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4">
              {t("faq.title")}
            </h2>
            <p className="text-base sm:text-lg text-gray-600">
              {t("faq.subtitle")}
            </p>
          </div>
        </ScrollReveal>

        <div className="max-w-3xl mx-auto">
          <ScrollReveal>
            <Accordion type="single" collapsible className="space-y-3 sm:space-y-4">
              {faqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="bg-white rounded-lg border border-gray-200 px-4 sm:px-6"
                >
                  <AccordionTrigger className="text-left font-semibold py-4 sm:py-6 text-sm sm:text-base">
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 pb-4 sm:pb-6 text-sm sm:text-base">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </ScrollReveal>
        </div>

        <ScrollReveal delay={300}>
          <div className="mt-12 sm:mt-16 p-6 sm:p-8 bg-white rounded-xl border border-gray-200 text-center max-w-2xl mx-auto shadow-sm">
            <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-gray-900">
              {t("faq.cta.title")}
            </h3>
            <p className="text-gray-600 mb-6 sm:mb-8 text-base sm:text-lg">
              {t("faq.cta.subtitle")}
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
              <Link to="/demo#demo-request-form">
                <Button 
                  size="lg" 
                  className="w-full sm:w-auto px-6 sm:px-8 py-3 bg-brand-600 hover:bg-brand-700 text-white font-semibold rounded-lg shadow-md transition-all duration-200 hover:shadow-lg"
                >
                  {t("faq.cta.demoButton")}
                </Button>
              </Link>
              <Link to="/pricing">
                <Button 
                  variant="outline" 
                  size="lg"
                  className="w-full sm:w-auto px-6 sm:px-8 py-3 border-2 border-brand-600 text-brand-600 hover:bg-brand-50 font-semibold rounded-lg transition-all duration-200 hover:border-brand-700 hover:text-brand-700"
                >
                  {t("faq.cta.pricingButton")}
                </Button>
              </Link>
            </div>
            <p className="mt-4 sm:mt-6 text-xs sm:text-sm text-gray-500">
              {t("faq.cta.trial")}
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default FAQ;
